<div class="mb-5" ngbDropdown [autoClose]="false" placement="bottom-left" (openChange)="dropdownToggled($event)">
  <div class="input-group">
    <input
      #input
      type="text"
      class="form-control"
      [class.is-invalid]="!isValid"
      [placeholder]="state.mask"
      (input)="inputChange()"
      [disabled]="state.disabled"
      (blur)="onTouched()"
    />
    <div class="input-group-append">
      <button
        class="dropdown-toggle fa-calendar input-group-text"
        ngbDropdownToggle
        type="button"
        [disabled]="state.disabled"
      ></button>
    </div>
  </div>
  <div *ngIf="!isValid" class="invalid-feedback">{{ errorMessage }}</div>
  <div *ngIf="state.opened && state.mode !== 'mobile'" ngbDropdownMenu class="dropdown-menu">
    <div class="row m-0">
      <button class="btn arrow-left col-4" type="button" (click)="addYear($event, -1)" #focusTrap>
        <span class="fa-angle-left"></span>
      </button>
      <button *ngIf="state.mode !== 'year'" class="btn btn-link col-4" type="button" (click)="toggleMode($event)">
        {{ state.selected.year }}
      </button>
      <button *ngIf="state.mode === 'year'" class="btn btn-link col-4" type="button" (click)="toggleMode($event)">
        {{ baseYear + 1 }}-{{ baseYear + 10 }}
      </button>
      <button class="btn arrow-right col-4" type="button" (click)="addYear($event, +1)" #focusTrap>
        <span class="fa-angle-right"></span>
      </button>
    </div>
    <div class="row m-0" tabindex="0" #focusTrap>
      <div
        *ngFor="let month of state.monthNames; let i = index"
        class="col-3 monthpicker__month{{ getItemClasses(i) }}"
        (click)="$event.stopPropagation(); onClick(i)"
      >
        <span *ngIf="state.mode === 'year'">{{ i + baseYear }}</span>
        <span *ngIf="state.mode === 'month'">{{ month }}</span>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="state.opened && state.mode === 'mobile'">
  <df-monthpicker-mobile-view class="monthpicker__mobile-panel"></df-monthpicker-mobile-view>
</ng-container>
